window.onload = function () {
  setTimeout(function () {
    const imac_image = document.getElementById("technology-hero-imac");
    if (imac_image) {
      if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
      }

      window.scrollTo(0, 0);
      gsap.to(imac_image, {
        opacity: 1,
        y: 0,
        duration: 3,
        ease: "power2.out",
      });
    }
  }, 100);
};

document.addEventListener("DOMContentLoaded", () => {
  const tech_title = document.getElementById("technology-title");

  const imac_arrow_image = document.getElementById(
    "technology-hero-imac-arrow"
  );
  const iphone_image = document.getElementById("technology-hero-iphone");
  const iphone_arrow_image = document.getElementById(
    "technology-hero-iphone-arrow"
  );
  const rate_image = document.getElementById("technology-hero-best-rate");
  const arrow_center_image = document.getElementById(
    "technology-hero-center-arrow"
  );
  const send_rc_button = document.getElementById("technology-hero-rc-sent");
  const bidding_button = document.getElementById("technology-hero-bidding");
  const ai_button = document.getElementById("technology-hero-post-quote-ai");
  const post_quote_button = document.getElementById(
    "technology-hero-post-quote"
  );
  const accepted_button = document.getElementById(
    "technology-hero-rc-accepted"
  );
  const send_rc_block = document.getElementById("technology-hero-send-rc");
  const rand_anim_objs = document.querySelectorAll(".anim-rand");

  function animateRandomly(element) {
    gsap.to(element, {
      x: Math.random() * 10 - 3, // Random value between -5 and 5
      y: Math.random() * 10 - 3,
      duration: 1.5,
      ease: "power1.inOut",
      onComplete: () => animateRandomly(element),
    });
  }

  rand_anim_objs.forEach(animateRandomly);

  if (tech_title) {
    ScrollTrigger.create({
      trigger: tech_title,
      start: "top 85%", // Adjust this to control when the animation starts
      end: "bottom center",
      onEnter: () => {
        gsap.timeline().to(tech_title, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
        });
      },
    });
  }
  if (imac_arrow_image) {
    gsap.fromTo(
      imac_arrow_image,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 3,
        ease: "power3.out",
        onComplete: () => animateRandomly(imac_arrow_image),
      }
    );
  }
  if (ai_button) {
    gsap.fromTo(
      ai_button,
      { y: "200px" },
      {
        y: 0,
        duration: 3,
        delay: 4,
        ease: "power3.out",
        onComplete: () => animateRandomly(ai_button),
      }
    );
  }
  if (post_quote_button) {
    gsap.fromTo(
      post_quote_button,
      { y: "200px" },
      {
        y: 0,
        duration: 3,
        delay: 2,
        ease: "power3.inOut",
        onComplete: () => animateRandomly(post_quote_button),
      }
    );
  }
  if (send_rc_button) {
    gsap.fromTo(
      send_rc_button,
      { scale: 0 },
      { scale: 1, duration: 3, delay: 5, ease: "power3.out" }
    );
  }

  if (bidding_button) {
    gsap.fromTo(
      bidding_button,
      { scale: 0 },
      { scale: 1, duration: 3, delay: 6, ease: "power3.out" }
    );
  }
  if (rate_image) {
    gsap.fromTo(
      rate_image,
      { opacity: 0 },
      { opacity: 1, duration: 3, delay: 4, ease: "power3.out" }
    );
  }
  if (arrow_center_image) {
    gsap.fromTo(
      arrow_center_image,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 3,
        delay: 3,
        ease: "power3.out",
        onComplete: () => animateRandomly(arrow_center_image),
      }
    );
  }
  if (send_rc_block) {
    gsap.fromTo(
      send_rc_block,
      { opacity: 0 },
      { opacity: 1, duration: 3, ease: "power3.out" }
    );
  }

  if (iphone_image) {
    gsap.fromTo(
      iphone_image,
      { x: "-200%" },
      { x: 0, duration: 4, delay: 0.1, ease: "power3.out" }
    );
  }
  if (iphone_arrow_image) {
    gsap.fromTo(
      iphone_arrow_image,
      { x: "-200%" },
      {
        x: 0,
        duration: 4,
        delay: 0.8,
        ease: "power3.out",
        onComplete: () => animateRandomly(iphone_arrow_image),
      }
    );
  }

  const sprinter_image = document.getElementById("technology-hero-sprinter");
  const road_track_image = document.getElementById("technology-hero-road");
  const road_track_image_mobile = document.getElementById(
    "technology-hero-road-mobile"
  );
  const tooltip_image = document.getElementById("technology-hero-tooltip");

  // Create a GSAP timeline
  const tl = gsap.timeline({
    delay: 2, // Delay the start of the timeline by 1 second
  });

  // Add animations to the timeline
  if (road_track_image_mobile) {
    tl.fromTo(
      road_track_image_mobile,
      { x: "150%", y: "80%" },
      { x: 0, y: 0, duration: 2, ease: "power3.out" }
    );
  }
  if (road_track_image) {
    tl.fromTo(
      road_track_image,
      { x: "150%", y: "80%" },
      { x: 0, y: 0, duration: 2, ease: "power3.out" }
    );
  }

  if (sprinter_image) {
    tl.fromTo(
      sprinter_image,
      { x: "150%" },
      { x: 0, duration: 2, ease: "power3.out" },
      "-=2" // Start 1.5 seconds after the road animation begins
    );
  }

  if (tooltip_image) {
    tl.fromTo(
      tooltip_image,
      { opacity: 0 },
      { opacity: 1, duration: 1, ease: "power3.out" },
      "-=0.5" // Start 0.5 seconds after the previous animation ends
    );
  }

  // Play the timeline
  tl.play();

  let tl_accepted = null;
  let tl_loop = null;

  function createAcceptedTimeline() {
    const availableWidth = document.documentElement.clientWidth;

    // if (availableWidth >= 1903) {
    //   if (tl_accepted) {
    //     tl_accepted.kill();
    //   }
    //   if (tl_loop) {
    //     tl_loop.kill();
    //   }

    //   // Create the main timeline
    //   tl_accepted = gsap.timeline({
    //     delay: 4,
    //     defaults: { ease: "power2.out" },
    //   });

    //   tl_accepted
    //     .set(accepted_button, { scale: 0, opacity: 0 }) // Set initial position
    //     .to(accepted_button, {
    //       scale: 1,
    //       opacity: 1,
    //       duration: 2,
    //       delay: 5,
    //       ease: "power3.out",
    //     })
    //     .to(accepted_button, {
    //       x: "28rem",
    //       duration: 1.5,
    //       delay: 0.4,
    //       ease: "expo.out",
    //     })
    //     .to(accepted_button, {
    //       x: "9rem",
    //       duration: 1.5,
    //       ease: "power3.inOut", // Changed to inOut for slower end
    //     });

    //   tl_loop = gsap.timeline({
    //     repeat: -1,
    //   });

    //   tl_loop
    //     .to(accepted_button, {
    //       x: "28rem",
    //       delay: 0.4,
    //       duration: 1.5,
    //       ease: "expo.out",
    //     })
    //     .to(accepted_button, {
    //       x: "9rem",
    //       duration: 1.5,
    //       ease: "power3.out", // Changed to inOut for slower end
    //     });

    //   tl_accepted.add(tl_loop);
    // } else {
      // if (tl_accepted) {
      //   tl_accepted.kill();
      //   tl_accepted = null;
      // }
      // if (tl_loop) {
      //   tl_loop.kill();
      //   tl_loop = null;
      // }

      // Smoothly set opacity to 1 over 2 seconds
     
    // }
  }
  if(accepted_button) {
    gsap.to(accepted_button, {
      opacity: 1,
      duration: 2, 
      scale: 1,
      delay: 5, 
      ease: "power2.out",
      onComplete: () => animateRandomly(accepted_button),
    });
    // createAcceptedTimeline();
  }

  window.addEventListener("resize", function () {
    if(accepted_button) {
      createAcceptedTimeline();
    }
  });

  const blocksCntWithImg = document.querySelectorAll(".content-with-image");
  blocksCntWithImg.forEach((block, index) => {
    if (block) {
      ScrollTrigger.create({
        trigger: block,
        start: "-200px center",
        end: "bottom center",
        onEnter: () => {
          gsap.fromTo(
            block.querySelector(".content-with-image-img"),
            { x: 500, opacity: 0 },
            { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
          );
        },
      });
    }
  });
  const blocksCntWithImgPortal = document.querySelectorAll(".content-with-image-portal");
  blocksCntWithImgPortal.forEach((block, index) => {
    if (block) {
      ScrollTrigger.create({
        trigger: block,
        start: "-200px center",
        end: "bottom center",
        onEnter: () => {
          gsap.fromTo(
            block.querySelector(".content-with-tour__wrap"),
            { y: 200, opacity: 0 },
            { y: 0, opacity: 1, duration: 2, ease: "power3.out" }
          );
        },
      });
    }
  });
  const blocks = document.querySelectorAll(".side-by-side-tech");
  blocks.forEach((block, index) => {
    if (block) {
      ScrollTrigger.create({
        trigger: block,
        start: "-200px center",
        end: "bottom center",
        onEnter: () => {
          // Animate the image
          gsap.to(block.querySelector(".side-by-side-tech-image"), {
            x: 0,
            opacity: 1,
            duration: 2.3,
            ease: "power3.out",
          });
        },
      });
    }
  });
  const blocksPortal = document.querySelectorAll(".side-by-side-portal");
  blocksPortal.forEach((block, index) => {
    if (block) {
      ScrollTrigger.create({
        trigger: block,
        start: "-200px center",
        end: "bottom center",
        onEnter: () => {
          // Animate the image
          gsap.to(block.querySelector(".side-by-side-portal-image"), {
            x: 0,
            opacity: 1,
            duration: 2.3,
            ease: "power3.out",
          });
        },
      });
    }
  });

  /* Technology Cards
    --------------------------------------------- */
  if (document.querySelector(".technology-cards-items")) {
    ScrollTrigger.create({
      trigger: ".technology-cards-items",
      onEnter: () => {
        gsap.fromTo(
          ".technology-cards-item:nth-child(1)",
          { x: -500, opacity: 0 },
          { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
        );

        gsap.fromTo(
          ".technology-cards-item:nth-child(2)",
          { x: 500, opacity: 0 },
          { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
        );
      },
      once: true,
    });
  }
  /* Technology Steps
    --------------------------------------------- */
  if (document.querySelector(".technology-steps-items")) {
    ScrollTrigger.create({
      trigger: ".technology-steps-items",
      start: "top bottom",
      end: "bottom top",
      onEnter: () => {
        gsap.fromTo(
          ".technology-steps-items",
          { y: 0, opacity: 0 },
          { y: 0, opacity: 1, duration: 2.3, ease: "power3.out" }
        );
      },
      once: true,
    });
    ScrollTrigger.create({
      trigger: ".technology-steps-item",
      onEnter: () => {
        gsap.fromTo(
          ".technology-steps-item:nth-child(1)",
          { x: -500, opacity: 0 },
          { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
        );

        gsap.fromTo(
          ".technology-steps-item:nth-child(3)",
          { x: 500, opacity: 0 },
          { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
        );
      },
      once: true,
    });
  }
});
